import React, { useState, useRef, useEffect } from "react";
import styles from "./downloadButton.module.css";
import { Tooltip } from "../Tooltip";
import { OI } from "../../onam/mark";
import { FEATURES } from "../../onam/features";

function DownloadButton({
  element_color,
  downloadCSV,
  downloadJSON,
  downloadPDF,
  showJson = true,
}) {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      style={{ position: "relative", display: "inline-block" }}
      ref={dropdownRef}
      className={styles.downloadWrapper}
    >
      <Tooltip text="Download/Export" placement="top">
        <button
          type="button"
          style={{
            background: "none",
            cursor: "pointer",
            padding: "4px",
            borderRadius: "6px",
            border: "1px solid transparent",
            transition: "transform var(--transition-xs, 0.2s) ease, border var(--transition-xs, 0.2s) ease",
          }}
          onClick={() => setShowDropdown((prev) => !prev)}
          className={styles.downloadButton}
        >
          {FEATURES.curationSkin ? <OI n="download" size={20} /> : (
<svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill={element_color}
            viewBox="0 0 24 24"
          >
            <path d="M12 16l5-5h-3V4h-4v7H7l5 5zM5 18h14v2H5z" />
          </svg>
)}
        </button>
      </Tooltip>

      {showDropdown && (
        <div
          className={`${styles.downloadDropdown} dropdown-open`}
          style={{
            position: "absolute",
            top: "85%",
            right: 0,
            background: "#fff",
            border: "1px solid #ccc",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            borderRadius: "6px",
            zIndex: 1000,
            minWidth: "80px",
            animation: "fadeSlide 0.2s ease",
          }}
        >
          <button type="button" style={dropdownItemStyle} onClick={downloadCSV}>
            CSV
          </button>
          {showJson && (
            <button type="button" style={dropdownItemStyle} onClick={downloadJSON}>
              JSON
            </button>
          )}
          <button type="button" style={dropdownItemStyle} onClick={downloadPDF}>
            PDF
          </button>
        </div>
      )}
    </div>
  );
}

const dropdownItemStyle: React.CSSProperties = {
  display: "block",
  width: "100%",
  padding: "10px 14px",
  cursor: "pointer",
  fontSize: "14px",
  border: "none",
  textAlign: "left",
};

export default DownloadButton;
